export const convertCountryCodesToCountries = (countries: Country[], countryCodes: string[]): Country[] => {
  return countries?.filter((country: Country) => country.countryCode && countryCodes.includes(country.countryCode))
}

export const convertCountryIdsToCountries = (countries: Country[], countryIds: number[]): Country[] => {
  return countries?.filter((country: Country) => countryIds.includes(country.id))
}

export const getCountryCodeByCountryId = (countries: Country[], countryId: number): string | undefined => {
  const country = countries?.find((country: Country) => country.id === countryId)
  return country?.countryCode
}
